<template>
    <v-container class="d-flex justify-center pa-0">
      <v-card style="padding-left: 20px; padding-right: 20px; padding-top: 10px; border-radius: 10px; margin-top:3px;">
      <v-card
        style="width: 800px; padding: 0; margin-top: 10px; margin-bottom: 10px; border-radius: 10px; "
        class="custom-shadow pa-4"
        elevation="10"
       
      >
        <v-row>
          <v-col>
            <span class="font-weight-bold" style="color: #2e7917; font-size: 17px; font-family: 'Inter', sans-serif;">
              Marketplace Integration
            </span>
  
            <h2 class="font-weight-bold" style="font-family: fields, sans-serif; font-style: normal; font-weight: 200;">
              Benefit Allocation Systems’ Cobra Control Services
            </h2>
            <span style="margin-top: 15px; font-family: 'Inter', sans-serif;">
              Complete, turnkey COBRA Administration, seamlessly integrated with your BambooHR account.
            </span>
          </v-col>
        </v-row>
  
        <hr style="border: 1px solid #e0e0e0; margin-top: 10px">

        <!--    next part -->

        <v-row style="margin-left:0px; margin-top: 10px;">
            <span class="font-weight-bold" style="color: #2e7917; font-family: fields, sans-serif;
font-style: normal; font-size: larger; font-weight: 700; ">Service Quote</span>
        </v-row>
        
        <v-row style="margin-top: 5px; ">
          <v-col cols="6">
  
            <span style="font-family: 'Inter', sans-serif;">Organization Name</span>
            <!-- Input Fields -->
            <v-row class="pa-0" >
              <v-col class="pa-0">
                <v-text-field
                  v-model="orgName"
                  outlined
                  dense
                  required
                  :rules="[validOrgName]"
                  style="max-width: 303px; height: 40px; margin-top:10px; margin-left: 10px; margin-bottom: 20px;"
                  class="custom-input"
                ></v-text-field>
              </v-col>
            </v-row>
            <span style="font-family: 'Inter', sans-serif;">First Name</span>
            <v-row class="pa-0" >
              <v-col class="pa-0">
                <v-text-field
                  v-model="firstName"
                  outlined
                  dense
                  required
                  :rules="[validName]"
                  style="max-width: 303px; height: 40px; margin-top:10px; margin-left: 10px; margin-bottom: 20px;"
                  class="custom-input"
                ></v-text-field>
              </v-col>
            </v-row>
            <span style="font-family: 'Inter', sans-serif;">Last Name</span>
            <v-row class="pa-0">
              <v-col class="pa-0">
                <v-text-field
                  v-model="lastName"
                  outlined
                  dense
                  required
                  :rules="[validName]"
                  style="max-width: 303px; height: 40px; margin-top:10px; margin-left: 10px; margin-bottom: 20px;"
                  class="custom-input"
                ></v-text-field>
              </v-col>
            </v-row>

            <span style="font-family: 'Inter', sans-serif;">Email Address</span>

            
            <v-row class="pa-0">
    <v-col class="pa-0">
      <v-text-field
                  v-model="email"
                  outlined
                  dense
                  required
                  :rules="[validEmail]"
                  style="max-width: 336px; height: 40px; margin-top:10px; margin-left: 10px; margin-bottom: 20px;"
                  class="custom-input"
                  append-outer-icon="mdi-information"
                  @click:append-outer="showInfo('email')"
                  :style="{ '--v-text-field-label-font-size': '5px' }"
                >
     
        <!-- Clickable Info Icon with Popup -->
        <template v-slot:append-outer>
          <v-menu v-model="showEmailInfo" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" color="#2E7917" style="cursor: pointer;">
                mdi-information
              </v-icon>
            </template>

            <v-card class="transparent-card" dark>
    <v-card-text>
      Your email should be the same as the one you use in BambooHR.

    </v-card-text>
  </v-card>
          </v-menu>
        </template>
      </v-text-field>
    </v-col>
  </v-row>

           

  
            
      
            <span style="font-family: 'Inter', sans-serif;">Confirm Email</span>
            <v-row class="pa-0">
              <v-col class="pa-0">
                <v-text-field
                  v-model="confirmEmail"
                  outlined
                  dense
                  required
                  :rules="[validConfirmEmail]"
                  style="max-width: 303px; height: 40px; margin-top:10px; margin-left: 10px; margin-bottom: 20px;"
                  class="custom-input"
                ></v-text-field>
              </v-col>
            </v-row>
  
            <span style="font-family: 'Inter', sans-serif;">BambooHR Subdomain</span>
           

            
           
            <v-row class="pa-0 align-center">
              <v-col class="pa-0" style="flex-grow: 1;">
                <v-text-field
                  v-model="subdomain"
                  outlined
                  dense
                  required
                  style="max-width: 240px; height: 40px; margin-top:10px; margin-left: 10px; margin-bottom: 20px;"
                  class="custom-input"
                  :rules="[validSubdomain]"
                >
                  <template v-slot:append>
                    <span style="font-weight: bold; color: #2e7917; font-weight: 600; font-family: fields, sans-serif; font-style: normal;">.BambooHR.com</span>
                  </template>
           
                  <!-- Clickable Info Icon with Popup -->
                  <template v-slot:append-outer>
                    <v-menu v-model="showSubdomainInfo" offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" color="#2E7917" style="cursor: pointer;">
                          mdi-information
                        </v-icon>
                      </template>

                      <v-card class="transparent-card" dark>
                        <v-card-text>
                          A subdomain is the unique identifier of your BambooHR account.<br>
                          Example: If your login URL is <strong>company.BambooHR.com</strong>,then your subdomain is <strong>"company"</strong>.
                        </v-card-text>
                      </v-card>
                    </v-menu>
                  </template>
                </v-text-field>
              </v-col>
              <v-col class="pa-0" style="flex-grow: 0; margin-left: 15px; margin-top: -10px;">
                <v-btn
                  :loading="loading"
                  @click="handleClick"
                  outlined
                  rounded
                  small
                  :style="{
                    color: subdomainTestStatus === 'success' ? '#2e7917' : subdomainTestStatus === 'failure' ? '#d32f2f' : '#1976d2',
                    borderColor: subdomainTestStatus === 'success' ? '#2e7917' : subdomainTestStatus === 'failure' ? '#d32f2f' : '#1976d2',
                    backgroundColor: 'white',
                    textTransform: 'none',
                    fontWeight: '500',
                    fontSize: '13px',
                    padding: '0 20px',
                    height: '36px',
                    minWidth: '100px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                  }"
                  class="test-btn"
                >
                  {{
                    subdomainTestStatus === "success"
                      ? "✓ Valid"
                      : subdomainTestStatus === "failure"
                      ? "✗ Invalid"
                      : "Test"
                  }}
                  <template v-slot:loader>
                    <v-progress-circular size="18" indeterminate></v-progress-circular>
                  </template>
                </v-btn>
              </v-col>
            </v-row>

            <v-row style="margin-top: 25px;" class="justify-center">
              <v-btn  @click="getQuote" style="background-color: white; color: black; border-radius: 20px; border: 1px solid grey; text-transform: none; font-weight: normal;">
                Get Quote
              </v-btn>
            </v-row>


            
          
  
            <!-- Button -->
           
          </v-col>
  
          <!-- Other Content -->
           
          <v-col v-if="quote_generated == true" cols="6">
            
            <v-row>
              <v-col cols="10" style="margin-top: 0px;">
                <span style="color: black; font-weight: 600; font-style: italic;">Add "BAS" and our email CobraControlServices@CobraControl.com and MyEnrollServices@BASusa.com to your contacts to ensure our emails don't go to spam!</span>
                <span style="color: #2e7917; font-weight: bold; font-family: noto-serif-oriya, sans-serif;"> Check your email: Quote was sent to your email.</span>
              </v-col>
            </v-row>

            <v-row style="margin-top: 15px; margin-left:50px">
              <v-btn  @click="viewQuote" style="background-color: white; color: black; border-radius: 20px; border: 1px solid grey; text-transform: none; font-weight: normal;">
              View Quote
            </v-btn>
            </v-row>
  
  
            <v-row style="margin-top: 50px; margin-bottom: 1px;">
              <span style="font-size: 25px; color: #2e7917; font-family: fields, sans-serif;
font-style: normal; font-weight: bolder;" >Like the services quote?</span>
            </v-row>
  
            <v-row class="ma-0" style="margin-top: 30px;">
              <v-col class="justify-center pa-0">
                <span style="color: black; font-weight: 600; font-style: italic; font-family: 'Inter', sans-serif;">You can get started now with your integration or follow the link in your quote to begin the integration any time!</span>
              </v-col>
            </v-row>
  
            <v-row style="margin-top: 10px;" class="justify-center">
               <v-btn  @click="getStarted" style="background-color: white; color: black; border-radius: 20px; border: 1px solid grey; text-transform: none; font-weight: normal;">
                Get Started
               </v-btn>
            </v-row>
          </v-col>
        
          

          <v-col v-if="subdomainTestStatus === 'failure'" cols="6" class="d-flex justify-center align-center">
  <v-row class="text-justify d-flex flex-column align-center mr-1">
    <h3 style="color: red; margin-bottom: 0;">
      We could not find your subdomain
    </h3>
    <h3>
      Check the spelling of your subdomain and try again.
    </h3>

    <v-btn  @click="clearEntries" style="background-color: white; color: black; border-radius: 20px; border: 1px solid grey; text-transform: none; font-weight: normal;">
              Clear Entries
            </v-btn>
  </v-row>
</v-col>



          <v-col v-if="locked === 'islocked' " cols="6"  class="d-flex justify-center align-center">
            
            <v-row class="text-justify d-flex flex-column align-center mr-1">
              <h2 style="color: red">
                Unfortunately,
              </h2>
              <h3>
                you have made too many unsuccessful attempts. This application is locked, but you may retry in 5-minutes (after {{ unlockTime }}).
              </h3>
    <v-btn  @click="clearEntries" style="background-color: white; color: black; border-radius: 20px; border: 1px solid grey; text-transform: none; font-weight: normal;">
              Clear Entries
            </v-btn>
            </v-row>
    </v-col>            



    <v-col v-if=" locked === 'islocked_after' " cols="6"  class="d-flex justify-center align-center">
            
            <v-row class="text-justify d-flex flex-column align-center mr-1">
              <h2 style="color: green">
                Let's Go!
              </h2>
              <h3>
                The application lock has been removed, and you may try the Subdomain Test again!
              </h3>
              <h3>
                Thanks for your patience  & understanding!
              </h3>
    <v-btn  @click="clearEntries" style="background-color: white; color: black; border-radius: 20px; border: 1px solid grey; text-transform: none; font-weight: normal;">
              Clear Entries
            </v-btn>
            </v-row>
    </v-col>      
        
        </v-row>
       
  
        
      </v-card >
      <!-- Footer Logos -->
      <v-row style="margin-top: 1px; margin-left:50px" >
          <v-col cols="4">
            <v-img :src="logo1" alt="Company Logo" style="width: 120px; height: auto; margin-bottom: 0px;"></v-img>
          </v-col>
          <v-col cols="4">
            <v-img :src="logo2" alt="Company Logo" style="width: 150px; height: auto; margin-bottom: 0px;"></v-img>
          </v-col>
          <v-col cols="4" class="ma-0">
            <v-img :src="logo3" alt="Company Logo" style="width: 120px; height: auto; margin-bottom: 0px;"></v-img>
          </v-col>
        </v-row>
      </v-card>

      <v-dialog v-model="errorDialog" max-width="600px">
  <v-card>
    <v-card-title class="headline">Error</v-card-title>
    <v-card-text>
      <ul>
        <li v-for="(error, index) in errorMessages" :key="index">{{ error }}</li>
      </ul>
    </v-card-text>
    <v-card-actions>
      <v-btn color="primary" @click="errorDialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<v-dialog v-model="email_already_exists" max-width="700">
      <v-card>
        <v-card-title class="text-h6">The Email Address you provided is already associated with an account in our system.</v-card-title>
       
        <v-card-text style="font-size: 20px;">
          Click "yes" to go to your account or click "no" to exit this page
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn color="red" variant="text" @click="email_already_exists_no" style="color:white;">No</v-btn>
          <v-btn color="green" variant="text" @click="email_already_exists_yes" style="color:white;">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>



<v-dialog v-model="confirmDetails" max-width="400">
      <v-card>
        <v-card-title class="text-h6">Are you sure the details you provided are correct?</v-card-title>

        <v-card-actions class="justify-center">
          <v-btn color="red" variant="text" @click="confirmDetails = false" style="color:white;">No</v-btn>
          <v-btn color="green" variant="text" @click="confirmDetailsTrue" style="color:white;">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    



      <v-dialog v-model="lockoutDialog" max-width="500px">
      <v-card>
        <v-card-title class="headline">Too many failed attempts</v-card-title>
        <v-card-text>
          You have exceeded the maximum number of failed attempts to test your subdomain. Please try again after 5 minutes.
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="lockoutDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay v-if="second_loading" class="d-flex align-center justify-center">
      <v-progress-circular indeterminate color="#2e7917" size="70"></v-progress-circular>
    </v-overlay>

      <v-dialog v-model="failureDialog" max-width="500px">
      <v-card>
        <v-card-title
          class="headline"
          style="background-color: #f44336; color: white"
          >Subdomain is Not Correct</v-card-title>
        <v-card-text>
          The subdomain you entered does not appear to be correct. Close this
          window, enter the corrected subdomain and test again. If you continue
          to experience errors, please contact Cobra Control Services at 1-(888)-887-6187
          or Support@CobraControl.com
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="failureDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="successDialog" max-width="500px">
  <v-card>
    <v-card-title
      class="headline"
      style="background-color: #4caf50; color: white"
    >
      Subdomain is Correct
    </v-card-title>

    <v-card-text>
      Congratulations, you’ve entered a valid subdomain. You may continue
      with the setup. Simply close this message window and proceed to the
      next step.
    </v-card-text>

    <v-card-actions class="d-flex justify-center">
      <v-btn
        @click="successDialog = false"
        style="background-color: #4caf50 !important; color: white !important;"
      >
        Close
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>


    </v-container>
  </template>
  
 
<script>
import axios from "axios";
export default {
  data() {
    return {
      bulb: require("@/assets/bulb.png"),
      logo3: require("@/assets/cobra_services.png"),
        logo1: require("@/assets/companylogo.png"),
        logo2: require("@/assets/bamboohr.png"),
        isAdmin: "", 
      firstName: "",
      lastName: "",
      email: "",
      confirmEmail: "",
      orgName: "",
      subdomain: "",
      phone: "",
      account_number: null,
      second_loading: false,
      subdomainTestStatus: "default",
      errorDialog: false,
      errorMessages: [],
      successDialog: false,
      failureDialog: false,
      email_already_exists: false,
      confirmDetails: false,
      loading:false,
      failureCount: 0,
      lastFailedAttempt: null,
      lockoutDialog: false,
      resetTimeout: null,
      locked: 'notlocked',
      unlockTime: null,
      remainingTime: 0, 
      timer: null, 
      quote_id: null,
      lockDialogue: false,
      ipAddress: null,
      record_id: null,
      quote_generated: false,
      loaded:false,
      showSubdomainInfo: false,
      showEmailInfo: false,
      quote_record_id: "",
    };
  },
  mounted() {

    // Usage
// Sets a cookie for 7 days
//this.deleteCookie("testcookie");
    // Retrieve lock state from localStorage on component load
    setTimeout(() => {
      this.loaded = true; // Simulate a delay in loading
    }, 2000);
    const savedLocked = localStorage.getItem('locked');
  const savedUnlockTime = localStorage.getItem('unlockTime');

  if (savedLocked && savedUnlockTime) {
    const now = new Date();
    const unlockDate = new Date(savedUnlockTime);

    // Check if the unlock time has passed
    if (now < unlockDate) {
      // Lockout is still active
      this.locked = 'islocked';
      this.unlockTime = unlockDate.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      });
      this.startUnlockTimer(); // Start timer to continue countdown
    } else {
      // Lockout period has expired
      this.locked = 'islocked_after';
      localStorage.setItem('locked', 'islocked_after');
    }
  }
},
  computed: {
  formattedTime() {
    const minutes = String(Math.floor(this.remainingTime / 60)).padStart(2, '0');
    const seconds = String(this.remainingTime % 60).padStart(2, '0');
    return `${minutes}:${seconds}`;
  },
  
    methodUrl() {
      return location.href.toLowerCase().indexOf("bastest") > -1 ||
        location.href.toLowerCase().indexOf("myenroll") > -1 ||
        location.href.toLowerCase().indexOf("me360dev") > -1
        ? "/web_projects"
        : "http://localhost/web_projects";
    },
    },

  methods: {
    
  // check_email_exist(email_) {
  //   var self = this;
  //   axios
  //     .post(self.methodUrl + "/Bamboohr_backend/Bamboohr_WebMethods.aspx/check_email_exist", {
  //       email: email_,
  //     })
  //     .then((r) => {
  //       var result = r.data.d;
  //       if (result=="1") {
  //        console.log("Email already exists");
  //       } else if (result == "0") {
  //         setTimeout(() => {
  //           this.Create_BambooHR_Account_User();
  //         }, 100);
  //       }
  //     })
  //     .catch((e) => {
  //       console.log(e);
  //     });
  // },


  // Create_BambooHR_Account_User(){
  //   var self = this;
  //   axios
  //     .post(self.methodUrl + "/Bamboohr_backend/Bamboohr_WebMethods.aspx/Create_BambooHR_Account_User", {
  //       companyName: self.companyName,
  //       firstName:self.firstName, lastName:self.lastName,  mi:"",emailAddress:self.email_
  //     })
  //     .then((r) => {
  //       var result = r.data.d;
  //       if (result!="0") {
  //        console.log("Success");
  //       }else{j
  //         console.log("Failed");
  //       } 
        
  //     })
  //     .catch((e) => {
  //       console.log(e);
  //     });
  // },
  deleteCookie(name, path = '/', domain = window.location.hostname) {
    // Overwrite the cookie with the same path and domain, with an empty value.
    document.cookie = name + "=; path=" + path + "; domain=" + domain + ";";
},

// Usage

  clearEntries(){
    this.url = ''; // Reset the URL input
    this.orgName = '';
    this.firstName = '';
    this.lastName = '';
    this.email = '';
    this.confirmEmail = '';
    this.subdomain = '';
  },
  
    validName(value) {
    const pattern = /^[A-Za-z-]+$/;
    if (!value) {
      return "Name is required";
    } else if (value.length < 2 || value.length > 20) {
      return "Name must be between 2 and 20 characters";
    } else if (!pattern.test(value)) {
      return "Name contains invalid characters. Allowed characters: A-Z, a-z, -";
    } else {
      return true;
    }
  },
  validEmail(value) {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!value) {
      return "Email is required";
    } else if (!emailPattern.test(value)) {
      return "The email entered is not valid";
    } else {
      this.emailErrorMessage = "";
      return true;
    }
  },
  validConfirmEmail(value) {
    if (!value) {
      return "Confirm email is required";
    } else if (value !== this.email) {
      return "Emails do not match";
    } else {
      return true;
    }
  },
  validOrgName(value) {
    const pattern = /^[A-Za-z0-9@&\-'\s]+$/;

    if (!value) {
      return "Organization Name is required";
    } else if (value.length < 2 || value.length > 30) {
      return "Organization Name must be between 2 and 30 characters";
    } else if (!pattern.test(value)) {
      return "Organization Name contains invalid characters. Allowed characters: A-Z, a-z, 0-9, @, &, -, '";
    } else {
      return true;
    }
  },
  validSubdomain(value) {
    const pattern = /^[A-Za-z0-9-]+$/;
    if (!value) {
      return "Subdomain is required";
    } else if (value.length < 3 || value.length > 100) {
      return "Subdomain must be between 3 and 100 characters";
    } else if (!pattern.test(value)) {
      return "Subdomain contains invalid characters. Allowed characters: A-Z, a-z, 0-9";
    } else {
      this.url = `https://${value}.bamboohr.com`;
      //consol
      this.subdomain = value;
      return true;
    }
  },

  isFormValid() {
    return (
      this.validOrgName(this.orgName) === true &&
      this.validName(this.firstName) === true &&
      this.validName(this.lastName) === true &&
      this.validEmail(this.email) === true &&
      this.validConfirmEmail(this.confirmEmail) === true &&
       this.validSubdomain(this.subdomain) === true &&
      this.subdomainTestStatus === "success"
    );
  },


getStarted() {
  this.errorMessages = []; // Clear previous messages

  if (this.isFormValid()) {
    // Save form data to localStorage
    this.$router.push({ name: 'BeginIntegration' });


  } else {
    if (this.validOrgName(this.orgName) !== true) {
      this.errorMessages.push(this.validOrgName(this.orgName));
    }
    if (this.validName(this.firstName) !== true) {
      this.errorMessages.push(this.validName(this.firstName));
    }
    if (this.validName(this.lastName) !== true) {
      this.errorMessages.push(this.validName(this.lastName));
    }
    if (this.validEmail(this.email) !== true) {
      this.errorMessages.push(this.validEmail(this.email));
    }
    if (this.validConfirmEmail(this.confirmEmail) !== true) {
      this.errorMessages.push(this.validConfirmEmail(this.confirmEmail));
    }
    if (this.validSubdomain(this.subdomain) !== true) {
      this.errorMessages.push(this.validSubdomain(this.subdomain));
    }
    if (this.subdomainTestStatus !== 'success') {
      this.errorMessages.push('Subdomain test failed. Please test again.');
    }

    if (this.errorMessages.length > 0) {
      this.errorDialog = true;
    }
  }
},

setCookie(name, value, days) {
    let expires = "";
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
},




async confirmDetailsTrue(){
  this.confirmDetails = false;

  this.second_loading=true;
  

try {
  const response = await fetch('https://api.ipify.org?format=json');
  const data = await response.json();
  this.ipAddress = data.ip; // Set the IP address in the userIP variable
  console.log(this.ipAddress);
} catch (error) {
  console.error('Error fetching IP address:', error);
  this.ipAddress = 'Could not retrieve IP address';
}

  localStorage.setItem('firstName', this.firstName);
localStorage.setItem('email', this.email);
localStorage.setItem('subdomain', this.subdomain);

// Create data object to send

//   const data = {
//   OrgName: this.orgName,
//   FirstName: this.firstName,
//   LastName: this.lastName,
//   Email: this.email,
//   Subdomain: this.subdomain,
//   IpAddress: this.ipAddress
// };

// const queryString = Object.keys(data)
//   .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
//   .join('&');
// Usage
//setCookie("record_id", "12345", 7); // Sets a cookie for 7 days
const response = await axios.post(this.methodUrl+ "/bamboohr_backend/Bamboohr_sso_page.aspx/Write2FileMethod", {
OrgName: this.orgName,
FirstName: this.firstName,
LastName: this.lastName,
Email: this.email,
Subdomain: this.subdomain,
IpAddress: this.ipAddress
}, {
headers: { "Content-Type": "application/json" }
}).catch(error => {
console.error("Error:", error);
});

console.log(response.data);
const parsedData = JSON.parse(response.data.d); // Parse the string into an object
this.quote_record_id = parsedData.recordId;
console.log(parsedData.recordId);

// this.setCookie("record_id", parsedData.recordId);
// this.record_id = parsedData.recordId;

this.setCookie("OrgName", this.orgName);
this.setCookie("first_name", this.firstName);
this.setCookie("last_name", this.lastName);
this.setCookie("email", this.email);
this.setCookie("subdomain_value", this.subdomain);

    
try {
        const response = await axios.post(
          this.methodUrl+ "/bamboohr_backend/Bamboohr_sso_page.aspx/Checkemail_exist",
          { email: this.email },
          { headers: { "Content-Type": "application/json" } }
        );

        console.log("email exists: " + response.data.d);

        if (response.data.d == 1) {
          this.email_already_exists = true;
          //this.second_loading = false;
        } else {
          this.create_account();
         // this.save_pdf_to_rlog();
          
          
          this.quote_generated = true;
        }
      } catch (error) {
        console.error("Error - checkemail_exist:", error);
      } finally {
        //this.second_loading = false; 
      }
},



async get_quote_id(){
 var self = this;
 self.second_loading = true;
  console.log("insidee: " + this.account_number)

  try {
    const response = await axios.post(
      this.methodUrl+ "/bamboohr_backend/Bamboohr_sso_page.aspx/get_quote_id",
      { accnt_no: this.account_number }
    );
    this.record_id = response.data.d;
    console.log("record_id " + response.data.d);
    this.save_pdf_to_rlog();
  } catch (error) {
    console.error("Error - get_quote_id:", error);
  } finally {
    //self.second_loading = false;
  }      
},

async create_account(){
  var self = this;
  self.second_loading=true;
  try {
    
        const response = await axios.post(
          this.methodUrl+ "/bamboohr_backend/Bamboohr_sso_page.aspx/create_account",
          { email: this.email,
            companyName: this.orgName,
            first_name: this.firstName,
            last_name: this.lastName,
            subdomain: this.subdomain
           },
          { headers: { "Content-Type": "application/json" } }
        );

        self.account_number  = response.data.d;
        console.log("account number: " + this.account_number);
        
        self.get_quote_id();

        
        

       
      } catch (error) {
        console.error("Error - create_account:", error);
      } finally {
        this.second_loading = false; 
      }
},

async save_pdf_to_rlog() {
  let url = this.methodUrl+ "/BambooHrCostEstimate/WebService.asmx/SavePDF_to_DB";

  try {
    const response = await axios.post(
      url,
      { recordId: this.record_id },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    let result = response.data?.d;
    try {
      result = JSON.parse(result);
    } catch (e) {
      // Ignore JSON parse errors, use response as is
    }

    console.log(result);
    this.send_email();
  } catch (error) {
    console.error("save_pdf_to_rlog:", error);
  }
},

async send_email(){
  var self = this;
  self.second_loading=true;
  try {
    
        const response = await axios.post(
          this.methodUrl+ "/bamboohr_backend/Bamboohr_sso_page.aspx/send_email",
          {
            record_id: this.record_id,
            email: this.email
           },
          { headers: { "Content-Type": "application/json" } }
        );
        console.log(response.data.d);
       
      } catch (error) {
        console.error("Error - send_email:", error);
      } finally {
        this.second_loading = false; 
      }
},


email_already_exists_no(){
  window.location.href = "https://www.myenroll.com";
},

viewQuote(){
  let pdf_url = this.methodUrl+ `/BambooHrCostEstimate/ViewPdf.aspx?p=${this.record_id}`;
window.open(pdf_url, "_blank");
},

email_already_exists_yes(){
  this.second_loading = true;
  const clientId = 'developer_portal-9e366ea90fd3b98d5b4a61531c48dd3ee2cb6c3c'; 
    const state = Math.random().toString(36).substring(7); 
    const scope = 'openid+legacy.login+email+benefit';
    const redirectUri = `https://www.myenroll.com/web_projects/bamboohr_backend/Bamboohr_sso_page.aspx`;
    //const redirectUri = `http://localhost/web_projects/bamboohr_backend/Bamboohr_sso_page.aspx`;
    const authUrl = `https://${this.subdomain}.bamboohr.com/authorize.php?request=authorize&state=${state}&response_type=code&scope=${scope}&client_id=${clientId}&redirect_uri=${redirectUri}`;
    window.location.href = authUrl;
},

  async getQuote() {
    this.errorMessages = []; // Clear previous messages
    if (this.isFormValid()) {
      //window.location.href = "https://www.myenroll.com";
      this.confirmDetails = true;
    } else {
      // Collect error messages
      if (this.validOrgName(this.orgName) !== true) {
        this.errorMessages.push(this.validOrgName(this.orgName));
      }
      if (this.validName(this.firstName) !== true) {
        this.errorMessages.push(this.validName(this.firstName));
      }
      if (this.validName(this.lastName) !== true) {
        this.errorMessages.push(this.validName(this.lastName));
      }
      if (this.validEmail(this.email) !== true) {
        this.errorMessages.push(this.validEmail(this.email));
      }
      if (this.validConfirmEmail(this.confirmEmail) !== true) {
        this.errorMessages.push(this.validConfirmEmail(this.confirmEmail));
      }
      if (this.validSubdomain(this.subdomain) !== true) {
        this.errorMessages.push(this.validSubdomain(this.subdomain));
      }
      if (this.subdomainTestStatus !== 'success') {
        this.errorMessages.push('Subdomain test failed. Please test again.');
      }

      // Show the error dialog
      if (this.errorMessages.length > 0) {
        this.errorDialog = true;
      }
    }
  },

  async handleClick() {
    if (this.locked === 'islocked') {
      this.lockoutDialog = true;
      return; // Prevent further testing if locked
    }
    if (this.locked === 'islocked_after') {
      this.locked = 'notlocked';
    }
    this.loading = true;

    try {
      const response = await axios.post(
        this.methodUrl+ "/bamboohr_backend/CheckUrl.aspx",
        new URLSearchParams({ url: this.url }).toString(),
        {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        }
      );

      if (response.data === "success") {
        this.subdomainTestStatus = "success";
        this.successDialog = true;
      } else {
        this.subdomainTestStatus = "failure";
        this.failureDialog = true;
        this.handleFailure();
      }
    } catch (error) {
      console.error("Error:", error);
      this.subdomainTestStatus = "failure";
      this.failureDialog = true;
      this.handleFailure();
    } finally {
      this.loading = false;
    }
  },

  handleFailure() {
    const now = new Date();

    // Update last failed attempt and increment failure count
    this.lastFailedAttempt = now;
    this.failureCount++;

    // Lockout logic: Check if failure count exceeds 3
    if (this.failureCount > 3) {
      this.subdomainTestStatus = '3_failed_attempts';
      this.locked = 'islocked';
      this.lockoutDialog = true;

      // Set unlock time based on system time
      const unlockDate = new Date(now.getTime() + 5 * 60 * 1000); // 5 minutes later
      this.unlockTime = unlockDate.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      });

      // Save lock state and unlock time in localStorage
      localStorage.setItem('locked', 'islocked');
      localStorage.setItem('unlockTime', unlockDate);

      this.startUnlockTimer();
    }
  },
  startUnlockTimer() {
    this.getRemainingTime();

    this.timer = setInterval(() => {
      this.remainingTime = this.getRemainingTime();

      // Check if timer has expired
      if (this.remainingTime <= 0) {
        clearInterval(this.timer);
        this.resetFailureCount();
      }
    }, 1000);
  },
  getRemainingTime() {
    const now = new Date();
    const unlockDate = new Date(localStorage.getItem('unlockTime'));
    const remainingSeconds = Math.max(0, Math.floor((unlockDate - now) / 1000));
    this.remainingTime = remainingSeconds;

    // If time has passed, unlock form
    if (remainingSeconds <= 0) {
      this.locked = 'islocked_after';
      localStorage.setItem('locked', 'islocked_after');
    }
    return remainingSeconds;
  },
  resetFailureCount() {
    this.failureCount = 0;
    this.subdomainTestStatus = 'default';
    this.locked = 'islocked_after';
    this.remainingTime = 0;

    // Clear lock state from localStorage
    localStorage.removeItem('locked');
    localStorage.removeItem('unlockTime');
  },
},
beforeDestroy() {
  // Clear timer if component is destroyed
  if (this.timer) {
    clearInterval(this.timer);
  }
},
};
</script>

<style scoped>
.multicolor-bar {
background: linear-gradient(to right, #6e44ad, #c3449d, #f06a53, #ffcc00);
}

.text-justify {
text-align: justify; /* Justifies text */
}

.rounded-outlined-button {
border-radius: 8px;
width: 100px;
height: 40px;
border-width: 3px;
font-weight: bold;
}

.custom-input .v-input--is-focused .v-input__control {
border-width: 2px !important;
}

.custom-input {
height: 40px;
}

.custom-input .v-input__control {
height: 40px;
}

.custom-input .v-input__slot {
height: 40px;
}


/* Deep selector to target the append icon */
::v-deep .v-input__icon--append .mdi-information {
color: blue !important;
}

.logo {
    width: 100px;  /* Adjust logo size */
    margin: auto;
  }

</style>

